import React from 'react';
import PropTypes from 'prop-types';
import { Logger } from 'aws-amplify';

import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';

import {
  Button,
} from '@material-ui/core';

import {
  UserContext,
} from '../../user';


import { useDatasetTables } from '../hooks/useDatasetTables';

const logger = new Logger('DatasetTables');

const ROW_MODIFY_STATES = Object.freeze(
  Object.fromEntries(["INITIAL", "EDITING"].map((t) => [t, t]))
);

const getColumnValue = (originalColumnIndex, tableMeta) =>
  tableMeta.rowData[
    tableMeta.tableState.columnOrder?.indexOf(originalColumnIndex) ??
      originalColumnIndex
  ];

const rebuildObjFromRow = (columns, tableMeta) =>
  Object.fromEntries(
    columns.map((c, originalColumnIndex) => [
      c.name,
      getColumnValue(originalColumnIndex, tableMeta)
    ])
  );


const DefaultActionButton = ({ value, onEditStart, onEditFinish }) =>
  value === ROW_MODIFY_STATES.INITIAL ? (
    <Button onClick={onEditStart}> Edit </Button>
  ) : (
    <Button onClick={onEditFinish}> Save </Button>
  );

const EditableCell = ({ editing, value, onChange, tableMeta }) =>
  editing
    ? <input value={value} onChange={(e) => onChange(e.target.value)} />
    : value;

const actionColumnRenderFactory = (columns, onRowSave, actionButtonCmp) => (
  value,
  tableMeta,
  update
) =>
  actionButtonCmp({
    value,
    onEditStart: () => update(ROW_MODIFY_STATES.EDITING),
    onEditFinish: () => {
      const rowObj = rebuildObjFromRow(columns, tableMeta);
      onRowSave(rowObj);
      update(ROW_MODIFY_STATES.INITIAL);
    }
  });

const onRowSave = (mutatedRowObj) => {
    // backendCallPut(mutatedRowObj);
    // refresh();
    alert("Modified Object: " + JSON.stringify(mutatedRowObj, null, 2));
};

export default function DatasetTables(props) {

  const { resourceId } = props;
  const { tables, loading, error } = useDatasetTables({ resourceId: resourceId, debug: true });
  
  const userContext=React.useContext(UserContext); 

  if(error) {
    console.log("ERROR: ",error);
    return(<div>Errors: see console</div>);
  }
  if(!tables || loading) return(null); 

  const isAdmin = userContext.role==='Admin';

  logger.info("TABLES:",tables);
  const muiTheme = createMuiTheme({
    overrides: {
      MUIDataTable: {
        root: {
          size: "small"
        },
        paper: {
          boxShadow: "none",
        },
      },
      MuiTableCell: {
        root: {
          '&:nth-child(1)': {
            whiteSpace: 'nowrap',
          }
        }
      },
    }
  });

  const options = {
    enableNestedDataAccess: ".",
    print: false,
    download: false,
    filter: false,
    viewColumns: false,
    pagination: false,
    search: false,
    selectableRows: "none",
    setTableProps: () => {
      return {
        padding: "default",
        size: "small",
      };
    },
  };

  const columns = [
    { name: 'Table', options: { filter: false } },
    { name: 'Column', options: { filter: false } },
    { name: 'Type', options: { filter: false } },
    { name: 'Comment', options: { 
      filter: false,
      customBodyRender: (value, tableMeta, onChange) => {
        const uiState = getColumnValue(4, tableMeta);
        return (
          <EditableCell
            editing={uiState === ROW_MODIFY_STATES.EDITING}
            {...{ value, tableMeta, onChange }}
          />
        );
      }
    }},
  ];
  
  if(isAdmin) {
    columns.push({
        name: "uiState",
        label: "Action",
        options: {
          customBodyRender: actionColumnRenderFactory(columns, onRowSave, DefaultActionButton)
      }});
  }
  
  const columnData = tables.flatMap((table) =>{
    return table.StorageDescriptor.Columns.map((column) => {
      return { 
        'Table': table.Name, 
        'Column': column.Name, 
        'Type': column.Type, 
        'Comment': column.Comment || "",
        uiState: ROW_MODIFY_STATES.INITIAL, 
      };
    });
  });
  return (
    <MuiThemeProvider theme={muiTheme}>
      <MUIDataTable
        data={columnData}
        columns={columns}
        options={options}
      />
    </MuiThemeProvider>
  );
}


DatasetTables.propTypes = {
  resourceId: PropTypes.string.isRequired,
};

DatasetTables.defaultProps = {
};

